import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { Vehicles } from 'src/app/shared/model/vehicle.model';
import { CheckValidations } from 'src/app/shared/utils/checkValidations';

@Component({
  standalone: true,
  selector: 'app-step-replacement-vehicle',
  templateUrl: './step-replacement-vehicle.component.html',
  styleUrls: ['./step-replacement-vehicle.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatButtonModule,
    MatCheckboxModule,
    MatStepperModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class StepReplacementVehicleComponent implements OnChanges, OnInit {
  @Input() vehiclesArr!: Vehicles[];
  @Input() requestType!: string;
  @Input() stepper!: MatStepper;
  @Input() carType?: string;

  @Output() vehicleReplacementEmitter = new EventEmitter<any>();
  @Output() backStepEmitter = new EventEmitter();

  retributionText = '';
  estimatedKms = 0;
  form: FormGroup = this.fb.group({});
  //validations
  tmaimgKms = 0;
  tmaimgDate = 0;
  isKmsExceeded = false;
  monthsValue = 0;
  kilometers = 0;
  //errores
  errorRequest = false;
  vehicleSelected: Vehicles | undefined;
  requestTypeEnum = RequestType;

  landing2 = false;

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    private vehicleService: VehiclesService,
    private router: Router,
    private checkValidations: CheckValidations
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['vehiclesArr']) {
      this.form.get('vehicle')?.setValue(this.vehiclesArr[0]?.plateNumber);
      this.vehicleReplacement(this.vehiclesArr[0]);
      this.initForm();
    }
    this.form.valueChanges.subscribe(() => {
      this.changeEstimatedKms();
    });
  }
  initForm(): void {
    this.form = this.fb.group({
      vehicle: [
        !!this.vehiclesArr ? this.vehiclesArr[0] : [],
        [Validators.required]
      ],
      estimatedKms: [
        ,
        this.requestType === this.requestTypeEnum.innerRoute
          ? [Validators.min(1), Validators.pattern('^[0-9]*$')]
          : [
              Validators.required,
              Validators.min(1),
              Validators.pattern('^[0-9]*$')
            ]
      ]
    });
  }

  retributionTranslation(retribution: string): string {
    return retribution === 'PRIMARY'
      ? (this.retributionText = i18next.t('primary'))
      : (this.retributionText = i18next.t('Secundaria'));
  }

  changeEstimatedKms() {
    if (this.form.controls['estimatedKms'].valid) {
      this.errorRequest = false;
      this.errorRequest = this.checkValidations.checkValidations(
        this.form.value.estimatedKms,
        this.tmaimgKms,
        this.vehicleSelected?.deliveryDate,
        this.tmaimgDate
      );
    }
  }

  nextStep() {
    const replacementVehicle = {
      VIN: this.vehicleSelected?.VIN,
      estimatedKms: this.form.value.estimatedKms
    };
    this.vehicleReplacementEmitter.emit(replacementVehicle);
  }

  fetchValidations(tmaimg: string) {
    const requestTypeDotArr = this.storageService.get('requestCarType');

    if (this.requestType !== this.requestTypeEnum.innerRoute) {
      this.vehicleService
        .getValidations(
          tmaimg,
          requestTypeDotArr === 'endowmentLeasingEndowment'
            ? 'ENDOWMENT'
            : this.requestType
        )
        .subscribe({
          next: (data) => {
            this.errorRequest = false;
            this.tmaimgKms = data.kms || 0;
            this.tmaimgDate = data.months || 0;
            this.errorRequest = this.checkValidations.checkValidations(
              this.form.value.estimatedKms,
              this.tmaimgKms,
              this.vehicleSelected?.deliveryDate,
              this.tmaimgDate
            );
          },
          error: (error) => {
            console.error('Error al obtener validaciones:', error);
          }
        });
    }
  }

  selectReplacementVehicle() {
    this.getVehicleSelected(this.form.value.vehicle);

    if (!!this.vehicleSelected) {
      this.vehicleReplacement(this.vehicleSelected);
    }
  }

  getVehicleSelected(plateNumber: string) {
    this.vehicleSelected = this.vehiclesArr.find(
      (vehicle) => vehicle.plateNumber === plateNumber
    );
  }
  vehicleReplacement(value: Vehicles) {
    this.storageService.set('vehicleSustitution', value);
    this.getVehicleSelected(value?.plateNumber);
    if (this.vehicleSelected?.tmaimg) {
      this.fetchValidations(this.vehicleSelected.tmaimg);
    }
  }
  backStep() {
    this.stepper?.selectedIndex === 0
      ? this.landing2
        ? this.router.navigateByUrl('/landing-leasing')
        : this.router.navigateByUrl('/menu')
      : this.backStepEmitter.emit();
  }
}
